import { Col } from 'antd';
// eslint-disable-next-line max-len
import ReferenceDataDropdown from 'common/reference-data/containers/reference-data-dropdown-container';
import PropTypes from 'prop-types';
import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Dropdown, FormItem, Row } from 'ui';
import { referenceTypes } from '../../../utils/app-configs';
import { FormLabel, StyledCol } from './ticket-toolbar';

const StyledActionCol = styled(FormItem)`
  min-height: 0px;
  .ant-legacy-form-item-label {
    flex: 0 0 28% !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  label {
    white-space: nowrap;
  }
  .ant-legacy-form-item-control-wrapper {
    width: 72% !important;
  }
`;

const ExtraTicketToolbarRow = ({
  intl,
  isDisabled,
  form,
  data = {},
  metaData = {},
  isDiagnostics = false,
}) => {
  const { plannerGroup = null, closingReason = null, proposedActionId = null } = data;
  const { plant = null, closingReasonTranslations = [], proposedActions = [] } = metaData;
  const plannerGroupValidator = form.getFieldDecorator('plannerGroup', {
    initialValue: plannerGroup,
  });

  const proposedActionValidator = form.getFieldDecorator('proposedActionId', {
    initialValue: proposedActionId,
  });
  return <Row gutter={16} marginTop={8}>
    {isDiagnostics && closingReason && isToggleEnabled('ticketClosingReason') &&
      <StyledCol flex='0 0 25%'>
        <FormLabel
          label={`${intl.formatMessage({
            id: 'tickets.filters.closingReason',
          })}:`}
        >
          {closingReasonTranslations?.find(c => c?.id === closingReason)?.description ||
            intl.formatMessage({ id: 'ticket.UNKNOWN' })}
        </FormLabel>
      </StyledCol>}
    {isDiagnostics && <Col flex='0 0 25%'>
      <FormLabel
        label={`${intl.formatMessage({
          id: 'tickets.PLANNERGROUP',
        })}:`}
      >
        {plannerGroupValidator(
          <ReferenceDataDropdown
            placeholder={intl.formatMessage({
              id: 'equipment.organisation.SELECT_PLANNER_GROUP',
            })}
            disabled={isDisabled}
            width='235px'
            type={referenceTypes.equipment}
            name='plannerGroups'
            valueLabel='name'
            valueKey='number'
            urlParams={{ plant }}
          />,
        )}
      </FormLabel>
    </Col>
    }
    {isToggleEnabled('proposedActionDropdownForTickets') ?
      <Col flex='0 0 25%'>
        <StyledActionCol
          label={`${intl.formatMessage({
            id: 'tickets.PROPOSED_ACTION',
          })}:`}
        >
          {proposedActionValidator(
            <Dropdown
              onChange={v => form.setFieldsValue({ proposedActionId: v })}
              values={proposedActions}
              disabled={isDisabled}
              valueLabel='description'
              valueKey='id'
              dropdownMatchSelectWidth={false}
              allowClear={true}
              width='100%'
            />,
          )}
        </StyledActionCol>
      </Col> :
      null}
  </Row>;
};

ExtraTicketToolbarRow.propTypes = {
  intl: PropTypes.object,
  isDisabled: PropTypes.bool,
  data: PropTypes.object,
  form: PropTypes.object,
  metaData: PropTypes.object,
  isDiagnostics: PropTypes.bool,
};

export default injectIntl(ExtraTicketToolbarRow);
